export default {
  // Sustantivos / títulos generales del módulo
  item_group: 'Grupo de Item',
  forms: 'Formularios',
  group_forms: 'Agrupar formularios',
  test_forms: 'Test de Formularios',
  approver_forms: 'Revisión de Formularios',

  // Acciones sobre un formulario (menú de tarjeta — Item.vue, ItemTest.vue, ItemApprover.vue)
  preview: 'Previsualizar',
  edit: 'Editar formulario',
  edit_config: 'Configuración del formulario',
  delete: 'Eliminar formulario',
  download_pdf: 'Descargar PDF',
  send_test_email: 'Enviar por Correo',
  close: 'Cerrar',
  no_results: 'Sin Resultados',
  forms_selected: '{n} formularios seleccionados',
  select_placeholder: 'Seleccione',

  // Opciones de respuesta Sí/No/NA (FormGroup.vue, FieldYesNo.vue, FormTestYesNo.vue —
  // antes en i18n/items.js, movidas aquí en la Fase 5 por ser 100% del módulo Formularios)
  form_yes_no: {
    yes: 'Sí',
    no: 'No',
    na: 'NA'
  },

  form_checkitem: {
    unanswered: 'Sin Responder',
    na: 'N/A'
  },

  form_table: {
    add_row: 'Añadir fila',
    totals: 'Totales',
    simulate_import_totals: 'Simular importar totales',
    import_totals: 'Importar Totales'
  },

  form_reading: {
    last_reading_offline: 'Sin conexión: no se pudo obtener la lectura anterior. Puedes capturarla; ' +
      'al volver la conexión, si hay una auditoría anterior, se reemplazará por su lectura.'
  },

  form_catalog: {
    search_hint: 'Escribe mínimo 3 caracteres para buscar'
  },

  comments: {
    label: 'Comentarios adicionales'
  },

  // Historial de aprobación (ApprovalHistoryDialog.vue)
  approval_history: {
    title: 'Historial de Aprobación',
    loading: 'Cargando historial...',
    empty: 'Aún no hay actividad registrada para este formulario.',
    error: 'No se pudo cargar el historial de aprobación.',
    retry: 'Reintentar',
    close: 'Cerrar',
    no_comments: 'Sin comentarios',
    unknown_actor: 'Usuario desconocido',
    entry_type_test: 'Prueba',
    entry_type_comment: 'Comentario',
    status_testing: 'En prueba',
    status_completed: 'Prueba completada',
    status_pending_approval: 'Pendiente de aprobación',
    status_approved: 'Aprobado',
    status_rejected: 'Rechazado',
    status_changes_requested: 'Cambios solicitados',
    status_commented: 'Comentado',
    status_published: 'Publicado',
    status_untested: 'Sin probar'
  },

  // Resultados de prueba (TestResultsDialog.vue)
  test_results: {
    title: 'Resultados de Prueba',
    loading: 'Cargando resultados...',
    empty: 'Este formulario aún no tiene pruebas registradas.',
    error: 'No se pudieron cargar los resultados de prueba.',
    retry: 'Reintentar',
    close: 'Cerrar',
    unknown_tester: 'Tester desconocido',
    status_testing: 'En curso',
    status_completed: 'Completada',
    status_rejected: 'Rechazada',
    status_approved: 'Aprobada',
    status_commented: 'Con observaciones',
    status_published: 'Publicada',
    status_unknown: 'Sin estado'
  },

  // Complementos de un ítem (OccurrenceItemAddonDialog.vue, OccurrenceTaskAddSection.vue, stores/occurrences/actions.js)
  addons: {
    add_comment: 'Agregar comentario',
    add_picture: 'Agregar imagen',
    add_task: 'Agregar tarea',
    add_document: 'Agregar Documento',
    add_video: 'Agregar video',
    video_too_large: 'El video supera el tamaño máximo permitido (45 MB).',
    video_rejected_by_server: 'El servidor rechazó el video por su tamaño o formato. Se conserva en el dispositivo, pero no se podrá subir así.',
    video_upload_retry: 'No se pudo subir el video. Queda guardado en el dispositivo y se reintentará.'
  },

  // Estado del proceso de testing/aprobación (TestingProcessModal.vue)
  testing_process: {
    title: 'Estado del Proceso',
    process_info_title: 'Información del Proceso',
    sent_to_test_label: 'Enviado a Test:',
    process_status_label: 'Estado del Proceso:',
    rejection_reason_title: 'Motivo del Rechazo',
    rejection_reason_default: 'El formulario requiere correcciones.',
    comments_history_title: 'Historial de Comentarios',
    loading_history: 'Cargando historial...',
    no_comments: 'Sin comentarios registrados',
    resend_to_test: 'Reenviar a Test',
    send_to_test: 'Enviar a Test',
    edit_before_resend_tooltip: 'Debes editar el formulario antes de reenviarlo',
    go_to_editor: 'Ir a Editor',
    status_draft_label: 'Borrador',
    status_draft_description: 'El formulario está listo para enviarse a testing.',
    status_testing_label: 'En Testing',
    status_testing_description: 'El formulario está siendo evaluado por los testers.',
    status_tested_label: 'Probado',
    status_tested_description: 'El formulario fue probado exitosamente. Esperando aprobación.',
    status_approved_label: 'Aprobado',
    status_approved_description: 'El formulario fue aprobado y está listo para publicación.',
    status_rejected_label: 'Requiere Cambios',
    status_rejected_description: 'El formulario fue rechazado y requiere correcciones antes de continuar.',
    status_published_description: 'El formulario está publicado y disponible para uso.',
    badge_commented: 'Comentario',
    badge_rejected: 'Rechazado',
    badge_sent: 'Enviado',
    badge_testing: 'En Prueba',
    unknown_user_fallback: 'Usuario'
  },

  // Tarjeta de formulario en la lista de gestión (Item.vue)
  item: {
    tooltip_rejected: 'Cambios solicitados - Requiere correcciones del creador',
    tooltip_published: 'Formulario publicado y disponible para uso',
    tooltip_approved: 'Formulario aprobado - Listo para publicar',
    menu_view_process: 'Ver Estado del Proceso',
    menu_return_to_draft: 'Volver a Borrador',
    dialog_return_message: '¿Devolver el formulario "{name}" a borrador? Podrás editarlo y reenviarlo a prueba.',
    loading_return: 'Devolviendo a borrador...',
    notify_return_success: 'Formulario devuelto a borrador',
    notify_return_error: 'Error al devolver formulario a borrador',
    retry_caption: 'Inténtelo nuevamente',
    bottom_sheet_title: 'Formulario: {name}',
    dialog_send_title: 'Enviar a Test',
    dialog_send_message: '¿Está seguro de enviar este formulario a los testers para su revisión?',
    dialog_send_ok: 'Enviar',
    loading_send: 'Enviando formulario a pruebas...',
    notify_send_success: 'Formulario enviado a pruebas exitosamente',
    notify_send_error_fallback: 'Error al enviar formulario',
    notify_delete_success: 'Formulario eliminado exitosamente',
    notify_delete_error: 'Error al eliminar el formulario',
    notify_check_dependencies_error: 'Error al verificar dependencias',
    delete_dependencies_message_singular: `El formulario "{name}" tiene {count} registro asociado de actividad de rutina que será eliminado.
      <br><br>¿Desea continuar?`,
    delete_dependencies_message_plural: `El formulario "{name}" tiene {count} registros asociados de actividades de rutina que serán eliminados.
      <br><br>¿Desea continuar?`,
    tooltip_status_draft: 'Formulario listo para enviar a pruebas',
    tooltip_status_sent: 'Formulario enviado a testing - Esperando asignación',
    tooltip_status_testing: 'Formulario en proceso de testing',
    tooltip_status_tested: 'Formulario probado - Esperando aprobación',
    tooltip_status_approved: 'Formulario aprobado - Listo para publicar',
    tooltip_status_rejected: 'Formulario rechazado - Requiere correcciones',
    tooltip_status_published: 'Formulario publicado y disponible'
  },

  // Tarjeta de formulario en la lista de testing (ItemTest.vue)
  item_test: {
    tooltip_already_approved: 'Este formulario ya fue aprobado y no requiere más acciones',
    tooltip_rejected: 'Este formulario fue rechazado y requiere correcciones',
    badge_approved: '✓ Aprobado',
    badge_rejected: '✗ Rechazado',
    tooltip_has_comments: 'Tiene comentarios de prueba',
    tooltip_sent_by: 'Enviado por: {name}',
    tooltip_assigned_to: 'Asignado a: {name}',
    tooltip_sent_date: 'Enviado el: {date}',
    btn_comment: 'Comentar',
    btn_test: 'Probar',
    btn_continue_test: 'Continuar Prueba',
    btn_finish_test: 'Finalizar Prueba',
    btn_approve: 'Enviar a Aprobación',
    btn_reject: 'Rechazar formulario',
    chip_processed: 'Formulario procesado - No requiere acciones adicionales',
    rejection_reason_prefix: 'Motivo: {reason}',
    menu_view_history: 'Ver Historial de Pruebas',
    status_untested_label: 'Sin Probar',
    status_testing_label: 'En Prueba',
    status_tested_label: 'Probado',
    status_commented_label: 'Con Comentarios',
    status_approved_label: 'Aprobado',
    status_rejected_label: 'Rechazado',
    status_unknown_label: 'Desconocido',
    tooltip_status_untested: 'Este formulario no ha sido probado aún',
    tooltip_status_testing: 'Actualmente en proceso de prueba',
    tooltip_status_tested: 'Formulario probado, esperando aprobación',
    tooltip_status_commented: 'Formulario probado con comentarios pendientes',
    tooltip_status_approved: 'Formulario aprobado, listo para publicar',
    tooltip_status_rejected: 'Formulario rechazado, requiere correcciones',
    tooltip_status_published: 'Formulario publicado y disponible',
    loading_updating_list: 'Actualizando lista...',
    dialog_start_test_title: 'Iniciar Prueba',
    dialog_start_test_message: `¿Desea iniciar la prueba del formulario "{name}"? Será redirigido al modo de prueba donde podrá
      llenar el formulario.`,
    dialog_start_test_ok: 'Iniciar',
    notify_start_test_success: 'Redirigiendo al modo de prueba...',
    notify_start_test_success_caption: 'Podrá llenar el formulario y probarlo completamente',
    notify_start_test_error_fallback: 'Error al iniciar la prueba',
    dialog_continue_test_title: 'Continuar Prueba',
    dialog_continue_test_message: `¿Desea continuar con la prueba del formulario "{name}"? Será redirigido al modo de prueba donde
      podrá continuar llenando el formulario.`,
    dialog_continue_test_ok: 'Continuar',
    notify_continue_test_success: 'Continuando con la prueba...',
    notify_continue_test_success_caption: 'Podrá continuar llenando el formulario desde donde lo dejó',
    dialog_finish_test_message: '¿Desea finalizar la prueba del formulario "{name}"? Esto enviará el formulario para aprobación.',
    dialog_finish_test_ok: 'Finalizar',
    notify_finish_test_success: 'Prueba finalizada. Formulario enviado para aprobación.',
    notify_finish_test_error: 'Error al finalizar la prueba',
    dialog_add_comment_title: 'Agregar Comentario',
    dialog_add_comment_message: 'Ingrese su comentario:',
    loading_saving_comment: 'Guardando comentario...',
    notify_comment_added: 'Comentario agregado exitosamente',
    notify_comment_error: 'Error al agregar el comentario',
    dialog_view_history_title: 'Historial de Pruebas',
    dialog_view_history_message: 'Historial del formulario "{name}"\n\nPruebas realizadas: {count}',
    notify_history_error: 'Error al cargar el historial de pruebas',
    notify_delete_success: 'Formulario eliminado',
    notify_delete_error: 'Error al eliminar formulario',
    dialog_approve_message: `¿Desea enviar el formulario "{name}" a aprobación? Esto marcará el formulario como aprobado y listo
      para publicación.`,
    loading_approving: 'Enviando a aprobación...',
    notify_approve_success: 'Formulario enviado a aprobación exitosamente',
    notify_approve_success_caption: 'El formulario ha sido marcado como aprobado',
    notify_approve_error: 'Error al enviar a aprobación',
    dialog_reject_title: 'Rechazar Formulario',
    dialog_reject_message: 'Ingrese el motivo del rechazo (mínimo 10 caracteres):',
    dialog_reject_placeholder: 'Describa por qué se rechaza el formulario...',
    dialog_reject_ok: 'Rechazar',
    loading_rejecting: 'Rechazando formulario...',
    notify_reject_success: 'Formulario rechazado',
    notify_reject_success_caption: 'El formulario ha sido marcado como rechazado',
    notify_reject_error: 'Error al rechazar el formulario',
    dialog_publish_title: 'Publicar Formulario',
    dialog_publish_message: '¿Desea publicar el formulario "{name}"? Una vez publicado estará disponible para su uso.',
    dialog_publish_ok: 'Publicar',
    loading_publishing: 'Publicando formulario...',
    notify_publish_success: 'Formulario publicado exitosamente',
    notify_publish_success_caption: 'El formulario está ahora disponible para su uso',
    notify_publish_error: 'Error al publicar el formulario',
    dialog_return_draft_message: '¿Desea devolver el formulario "{name}" al estado de borrador? Esto permitirá editarlo nuevamente.',
    notify_return_success_caption: 'Ahora puede editarlo y corregir los problemas identificados',
    current_user_placeholder: 'Usuario Actual'
  },

  // Modo de prueba del formulario (FormTest.vue)
  form_test: {
    error_loading_test: 'Error: No se pudo cargar la información de la prueba',
    error_form_unavailable: 'Error: Información del formulario no disponible',
    test_occurrence_id_label: 'Test Occurrence ID: {id}',
    test_mode_label: 'Modo de Prueba:',
    loading_generic: 'Cargando...',
    test_mode_warning: 'Los datos ingresados no se guardarán en el sistema principal.',
    comments_section_title: 'Comentarios de Prueba',
    comments_placeholder: 'Ingrese aquí sus comentarios sobre la prueba del formulario...',
    comments_label: 'Observaciones de la prueba',
    dialog_send_email_title: 'Enviar formulario de prueba por correo',
    email_list_label: 'Escribe uno o más e-mails',
    send_pdf_notice: 'Se enviará un PDF del formulario en modo de prueba',
    error_form_id_missing: 'Form ID no encontrado en la ruta',
    error_init_test: 'Error al inicializar la prueba del formulario',
    error_unauthorized: 'No autorizado - Verifica tu sesión',
    error_forbidden: 'Sin permisos - Necesitas rol de form-tester',
    error_endpoint_not_found: 'Endpoint no encontrado - Verifica la configuración del API',
    error_server_prefix: 'Error del servidor: {message}',
    dialog_cancel_test_title: 'Cancelar Prueba',
    dialog_cancel_test_message: '¿Está seguro de cancelar la prueba? Se perderán todos los datos ingresados.',
    dialog_cancel_test_ok: 'Sí, cancelar',
    dialog_continue_testing: 'Continuar probando',
    dialog_finish_test_message: '¿Desea finalizar la prueba de este formulario? Se generará un reporte con sus comentarios.',
    loading_saving_test: 'Guardando datos de prueba...',
    notify_complete_success: 'Prueba completada correctamente',
    notify_complete_success_caption: 'Los datos han sido enviados a la base de datos de testing',
    notify_complete_error: 'Error al completar la prueba',
    validation_missing_answer: 'Falta responder item: {name}',
    validation_missing_picture: 'Falta agregar una imagen en: {name}',
    validation_missing_comment: 'Falta agregar un comentario en: {name}',
    dialog_validation_title: 'No se puede finalizar la prueba',
    dialog_validation_footer: 'Cumple con los requisitos del formulario y vuelve a intentar.',
    notify_pdf_unavailable: 'No hay datos de prueba disponibles para generar el PDF',
    loading_generating_pdf: 'Generando PDF de prueba...',
    default_test_location: 'Ubicación de Prueba',
    notify_pdf_success: 'PDF de prueba generado correctamente',
    notify_pdf_error: 'Error al generar el PDF de prueba',
    notify_mail_unavailable: 'No hay datos de prueba disponibles para enviar',
    notify_mail_success: 'Formulario de prueba enviado por correo',
    notify_mail_error: 'No se pudo enviar el formulario de prueba',
    default_tester_name: 'Usuario Test',
    error_empty_server_response: 'La respuesta del servidor está vacía',
    error_invalid_occurrence_response: 'La respuesta del servidor no es una occurrence válida',
    default_group_name: 'Sin grupo',
    // Encabezado de la prueba (FormTestHeader)
    default_form_name: 'Formulario de Prueba',
    test_mode_form_id_label: 'MODO DE PRUEBA - Form ID:',
    test_location_line: "Ubicación: '{location}'",
    test_score_label: 'PUNTAJE DE PRUEBA',
    below_standard: 'Bajo Estándar',
    test_mode_active: 'Modo de Prueba Activo - Los datos no se guardarán',
    test_in_progress: 'Prueba en curso',
    // Firmas simuladas (FormTestSignaturesSection)
    signatures_simulation_title: 'Simulación de Firmas (Modo Prueba)',
    signed: 'Firmado ✓',
    click_to_sign: 'Clic para simular firma',
    auditor_name_placeholder: 'Nombre del Auditor (Prueba)',
    audited_name_placeholder: 'Nombre del Auditado',
    signatures_notice: 'Las firmas están simuladas en modo de prueba. No se almacenarán en el sistema.',
    signatures_all_completed: 'Todas las firmas completadas',
    signatures_partial: 'Firmas parciales',
    signatures_none: 'Sin firmas',
    // Grupo de la prueba (FormTestGroupSection)
    default_test_group_name: 'Grupo de Prueba',
    // Complementos de pregunta (FormTestItemAddonDialog, FormTestItemAddonsSection)
    add_comment_test: 'Agregar comentario (Test)',
    add_picture_test: 'Agregar imagen (Test)',
    upload_picture_test: 'Subir imagen (Test)',
    comment_test_label: 'Comentario (Modo Test)',
    // Tipo de pregunta no soportado (FormTestItemField)
    unsupported_type_title: 'Tipo no compatible para testing',
    unsupported_type_message: 'El tipo {type} actualmente no está implementado para el modo de prueba.',
    info_button: 'Info',
    simulated_input_label: '{name} (Entrada simulada)',
    simulated_input_hint: 'Esta es una entrada genérica para continuar con la prueba',
    compatibility_info_title: 'Información de Compatibilidad',
    compatibility_current_type: 'Tipo actual:',
    compatibility_status: 'Estado:',
    compatibility_not_supported: 'No compatible para testing',
    compatibility_supported_types: 'Tipos compatibles:',
    compatibility_contact_dev: 'Para implementar este tipo, contacta al equipo de desarrollo.',
    // Lista de preguntas (FormTestItemList)
    test_chip: 'TEST',
    // Opciones (FormTestCheckbox, FormTestOption)
    option_alt: 'Option',
    no_options_configured: 'No hay opciones configuradas para este elemento en el formulario.',
    // Tabla (FormTestTable)
    simulate_import_totals: 'Simular Importar Totales',
    // Foto con IA simulada (FormTestUploadEditPicture)
    test_mode_picture_label: 'Modo Prueba',
    select_image_hint: 'Selecciona una imagen para probar la funcionalidad',
    analyzing_image_simulated: 'Analizando imagen (simulado)',
    test_evidence_alt: 'Evidencia de prueba',
    select_color: 'Seleccionar color',
    ai_approved_simulated: 'Imagen aprobada - Cumple con los criterios de evaluación (simulado)',
    ai_rejected_simulated: 'Imagen rechazada - No cumple con los criterios esperados (simulado)',
    simulate_ai: 'Simular IA',
    test_image_title: 'Imagen de Prueba',
    full_size_preview_alt: 'Full size preview',
    notify_edit_simulated: 'Función de edición simulada en modo prueba',
    notify_edit_simulated_caption: 'En producción se abriría el editor de imágenes',
    notify_no_ai_reference: 'Esta pregunta no tiene imagen de referencia para IA',
    notify_ai_simulated: 'Análisis de IA simulado completado',
    notify_ai_simulated_caption: 'En producción se conectaría con Ozaru Service'
  },

  // Formulario de creación/edición (Form.vue, admin)
  create: {
    standard: 'Estandar de la Compañía',
    field_label: 'Etiqueta de campo',
    name: 'Nombre del formulario',
    alias: 'Alias del formulario',
    form_save_confirm: 'Los cambios que estás a punto de guardar resultarán en perdida de la información actual.',
    form_save_confirm_second: `Hacer cambios a un formulario publicado eliminará incidencias* y es una acción NO REVERSIBLE,
      ¿Estás seguro de aplicar los cambios?<br>*Si se cambia el rol del Auditor se eliminan todas las incidencias.`,
    no_attachments: 'Sin adjuntos',
    no_comments: 'Sin comentarios',
    images: 'Imagenes',
    comment: 'Comentarios',
    text_close_action_plan_confirm: 'Para poder guardar el formulario necesitas cerrar el siguiente plan de accion: {name} , ¿Deseas cerrarlo?',
    published: 'Publicado',
    action_plan_pending: 'Plan de acción pendiente',
    notify_to: 'Con notificaciones por correo adicionales a:',
    notify_push_to: 'Con notificaciones push adicionales a:',
    at: 'a las',
    the: 'el',
    by: 'Por: ',
    close_at_ending_month: 'Cerrar al finalizar el mes',
    close_at_ending_periodicity: 'Basada en la fecha de inicio',
    restrict_by_area_help: 'El rol asignado solo podrá llenar el formulario estando físicamente en la ubicación',
    restrict_by_area: 'Activar geolocalización',
    loading: 'Cargando',
    email_not_valid: 'no es un correo válido',
    search_checklist: 'Busca un formulario',
    search_franchise: 'Buscar {franchise}',
    filter_locations: 'Filtrar Ubicaciones',
    search_role: 'Buscar un rol',
    search_user: 'Buscar usuario',
    every_two_weeks: 'Cada Quincena',
    will_open_soon: 'Este formulario abrirá próximamente',
    edit_checklist: 'Editar formulario',
    form_settings: 'Configuración formulario',
    delete_form: 'Eliminar formulario',
    locations: 'Ubicaciones',
    missed: 'Incumplimiento',
    below_standard: 'Debajo del estandar',
    unpublished: 'Sin publicar',
    activation: 'Activación',
    activation_help: 'Es el día a partir del cual se generarán ocurrencias para este formulario',
    periodicity: 'Periodicidad',
    assigned_to_roles: 'Asignación del formulario',
    assigned_to_roles_help: 'Selecciona el auditor, el auditado y supervisor',
    periodicity_help: 'Esta es la ocurrencia de tu formulario, diario, cada mes, etc.',
    duration: 'Duración',
    duration_help: 'Este es el tiempo el cual el formulario estará abierto',
    signatures: 'Firmas',
    notifications_email: 'Notificaciones por correo',
    notifications_push: 'Notificaciones push',
    notificate_to_user: 'Notificar al usuario',
    remind_to_user: 'Recordar al usuario',
    incomplete: 'Incumplimiento',
    name_help: 'Escribe un nombre para el formulario',
    create: 'Crear nuevo',
    empty_list: 'Ubicación sin formularios asignados',
    empty_list_action_plan: 'No hay planes de acción asignados',
    select_from_list: 'Selecciona una ubicación para ver sus formularios asignados',
    select_from_list_action_plan: 'Selecciona una ubicación para ver sus planes de acción asignados',
    checklist: 'Formulario',
    end_date: 'Fecha de cierre',
    form_start_hours: 'Abrirá a las',
    start_date: 'Fecha inicial',
    start_time: 'Iniciará a partir del:',
    by_time: 'Unidad de tiempo',
    special: 'Especial',
    end_time: 'Hasta',
    end_time_new: 'Y estará abierto por:',
    repeat_days: 'Se repetirá: ',
    repeat_every: 'Repetir cada',
    hours: 'Horas',
    days: 'Días',
    weeks: 'Semanas',
    months: 'Meses',
    years: 'Años',
    choose_a_day: 'Elige día',
    choose_a_month: 'Elige un mes',
    every_one_week: 'Cada semana los {weekdays}',
    every_n_weeks: 'Cada {n} semanas los {weekdays}',
    every_day: 'Diario',
    every_n_days: 'Cada {n} días',
    bussiness_days: 'Días hábiles (Lunes a Viernes)',
    mwf: 'Lunes, Miercoles y Viernes',
    tth: 'Martes y Jueves',
    every_one_month: 'Cada mes',
    every_n_months: 'Cada {n} meses',
    every_year: 'Cada año',
    every_n_years: 'Cada {n} años',
    by_event: 'Por evento desde {date}',
    by_calendar: 'Por calendario',
    from_start_date: 'desde',
    to_end_date: 'hasta',
    push: 'Enviar "Push Notification"',
    email: 'Enviar Correo Electrónico',
    delete_confirmation: '¿Desea eliminar el formulario "{name}"?',
    multiple_delete_confirmation: '¿Desea eliminar los planes de acción seleccionados?',
    roles_assignment: 'Auditor',
    delete_signature_confirmation: '¿Desea eliminar la firma?',
    yes: 'Sí',
    no: 'No',
    supervision: 'Asignar rol de supervisor',
    audited: 'Auditado',
    supervisor_role: 'Supervisor',
    audited_help: 'Persona al que se le realizará la auditoria',
    supervisor_role_help: 'Persona que le dara seguimiento al formulario',
    franchise: 'Unidad de negocio',
    franchise_help: '{franchise} a que pertenece el formulario',
    status: 'Estatus del formulario',
    open: 'Abierto',
    close: 'Cerrado',
    to_open: 'Por abrir',
    all: 'Todos',
    consolided_value: 'Valor consolidado',
    fill_help: 'Persona que llenará el formulario',
    doesnt_apply: 'No aplica',
    reset_incidence: 'Actualizar la ubicación borrará todas las respuestas. ¿Continuar?',
    responsability_label: 'Etiqueta 1',
    leadership_label: 'Etiqueta 2',
    signature_settings: 'Configuración de firma',
    notifications_settings: 'Configuración de Notificaciones',
    notify_review_complete: 'Notificaciones por correo al finalizar la revisión',
    notify_below_standard: 'Notificaciones por correo debajo del estandar',
    notify_review_complete_by_role: 'Notificaciones por correo al finalizar la revisión por rol',
    notify_push_below_standard: 'Notificaciones Push debajo del estandar',
    responsability_label_tooltip: 'Etiqueta de responsabilidad',
    leadership_label_tooltip: 'Etiqueta de jefatura',
    validation_name_suggest_alias: 'Te recomendamos agregar un alias',
    validation_alias_max_length: 'El alias no puede ser mayor a 25 caracteres',
    signature_customize_additional_label: 'Personalizar firmas adicionales',
    additional_signatures_label: 'Firmas adicionales',
    pdf_customization_title: 'Personalización de PDF',
    pdf_replace_logo_label: 'Sustituír logo en PDF',
    pdf_replace_company_label: 'Sustituír empresa en PDF',
    pdf_company_label: 'Empresa',
    extras_title: 'Extras',
    auto_action_plan_label: 'Planes de acción automáticos',
    action_plan_role_label: 'Rol',
    priority_label: 'Prioridad',
    priority_high: 'Alta',
    priority_medium: 'Media',
    priority_low: 'Baja',
    validity_days_label: 'Vigencia',
    informative_character_label: 'Caracter Informativo en Auditoría Integral',
    hide_pending_tasks_label: 'Ocultar tareas pendientes',
    hide_pending_tasks_tooltip: 'Al activarlo, la sección de tareas pendientes no se incluirá en el reporte generado.',
    publish_label: 'Publicar',
    allow_gallery_photos_label: 'Permitir Fotos desde Galería',
    hide_score_label: 'Esconder Calificación',
    routines_check_label: 'Rutinas',
    routines_check_tooltip: `El formulario solo podrá asignarse desde una rutina y podrá ser contestado hasta la fecha y hora
      establecida. (No podrá verse desde el modulo para contestar los formularios)`,
    editor_role_label: 'Rol Usuario Editor/Autorizador:',
    authorized_users_label: 'Usuarios Autorizadores (máximo 3):',
    ai_sensitivity_label: 'Sensibilidad evaluación de imágenes IA:',
    clone_label: 'Clonar',
    validation_roles_removed_warning: '¡Cuidado! Los roles no deben ser quitados del formulario. Por favor, contacte con su administrador.'
  },

  // Selector de ubicaciones de formularios asignados (AssignedList.vue)
  assigned_list: {
    no_locations_match: 'No se encontraron ubicaciones con esos criterios de búsqueda.',
    no_locations_nearby: 'No hay ubicaciones disponibles para sus coordenadas actuales.',
    no_locations: 'No hay ubicaciones disponibles.'
  },

  // Catálogo de tipos de ítem — constructor de formularios (ElementProps.vue)
  build: {
    label: 'Etiqueta',
    'form-checkbox': 'Selección de múltiples casillas',
    'form-checkitem': 'Selección de casilla única',
    'form-option': 'Opción múltiple',
    'form-select': 'Elegir de una lista',
    'form-yes-no': 'Sí/No/NA',
    'form-catalog': 'Seleccionar de un catálogo',
    'form-input-text': 'Texto',
    'form-textarea': 'Texto en parrafo',
    'form-input-email': 'Correo electrónico',
    'form-input-number': 'Campo numérico',
    'form-multinumeric': 'Campo multinumérico',
    'form-upload-file': 'Subir un archivo',
    'upload-edit-picture': 'Tomar fotografía',
    'form-location': 'Guardar ubicación',
    'form-date': 'Fecha',
    'form-hour': 'Hora',
    'form-table': 'Tabla',
    'form-reading': 'Registro numérico',
    'extra-properties-totals': 'Total de campos extra',
    'clone-item': 'Clonar ítem'
  }
}
